import { ChangeDetectorRef, Directive, ElementRef, Host, HostBinding, HostListener, Input, OnInit, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
    selector: 'button[closeDialog]'
})
export class CloseDialogDirective implements OnInit {

    @Input()
    @HostBinding('attr.arial-label')
    label = "";

    @HostListener('click',['$event'])
    onClick(event) {
        event.target.closest('dialog').close();
    }

    constructor(private _translateService: TranslateService, private _elm: ElementRef<HTMLButtonElement>, private _detector: ChangeDetectorRef) {}

    ngOnInit(): void {
        (this._elm.nativeElement as HTMLButtonElement).append(this.getIcon());
        this.label = this._translateService.instant('BUTTON.CLOSE');
        this._detector.markForCheck();
    }
    getIcon(): ChildNode {
        var div = document.createElement('div');
        div.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      role="img"
      aria-hidden="true"
      focusable="false">
     <use xlink:href="#close"
          href="#close">
     </use>
 </svg>
 `.trim();
        return div.firstChild;
    }


}
